import { BaseScene } from '@core/scenes/BaseScene';
import {
  SceneKeys,
  Palette,
  GAME_TITLE,
  STAGE_BG_TEXTURE,
  STAGE_BG_FILE,
} from '@core/config/constants';
import {
  CHARACTERS,
  GROUP_LINEUP_TEXTURE,
  GROUP_LINEUP_FILE,
} from '@core/config/characters';

const ASSETS_PATH = 'assets';

/**
 * Carga los recursos compartidos y muestra una barra de progreso. Cuando se agreguen
 * assets reales (sprites, audio) se cargan aca con this.load.* dentro de preload().
 */
export class PreloadScene extends BaseScene {
  public constructor() {
    super(SceneKeys.Preload);
  }

  public preload(): void {
    this.renderLoadingUi();

    this.load.image(STAGE_BG_TEXTURE, `${ASSETS_PATH}/${STAGE_BG_FILE}`);
    this.load.image(GROUP_LINEUP_TEXTURE, `${ASSETS_PATH}/${GROUP_LINEUP_FILE}`);
    CHARACTERS.forEach((character) => {
      this.load.image(character.texture, `${ASSETS_PATH}/${character.file}`);
    });
  }

  public create(): void {
    this.scene.start(SceneKeys.Hub);
  }

  private renderLoadingUi(): void {
    const { width, height } = this.scale;

    this.add
      .text(width / 2, height / 2 - 60, GAME_TITLE, {
        fontFamily: 'Trebuchet MS, sans-serif',
        fontSize: '48px',
        color: '#ffffff',
      })
      .setOrigin(0.5);

    const barWidth = 420;
    const barHeight = 28;
    const barX = (width - barWidth) / 2;
    const barY = height / 2 + 20;

    const border = this.add.graphics();
    border.lineStyle(3, Palette.accent, 1);
    border.strokeRoundedRect(barX, barY, barWidth, barHeight, 14);

    const fill = this.add.graphics();
    this.load.on('progress', (value: number) => {
      fill.clear();
      fill.fillStyle(Palette.primary, 1);
      fill.fillRoundedRect(barX + 4, barY + 4, (barWidth - 8) * value, barHeight - 8, 10);
    });
  }
}
